<template>
	<div v-if="showPopup" class="popup-overlay" @wheel.prevent @touchmove.prevent>
		<div class="popup-box" @click.stop>
			<div class="popup-top-right">
				<label class="checkbox-label">
					<input class="checkbox-label-input" type="checkbox" v-model="dontShowAgain" />
					<span class="checkbox-label-font">不再提示</span>
				</label>
				<button v-if="canClose" class="close-btn" @click="handleClose">✕</button>
				<span v-else class="countdown">({{ countdown }}秒)</span>
			</div>

			<div class="popup-content">
				<div class="popup-content-left">
					<div class="popup-content-left-img">
						<div class="popup-content-left-img-font">限时</div>
					</div>
					<div class="popup-content-left-model">
						<div class="popup-content-left-model-title">
							赠送学术资料大礼包
						</div>
						<div class="popup-content-left-model-body">
							<div class="popup-content-left-model-body-font"><img
									class="popup-content-left-model-body-font-img"
									src="../assets/gou.png" />10000字论文查重券+选题参考模板</div>
							<div class="popup-content-left-model-body-font"><img
									class="popup-content-left-model-body-font-img"
									src="../assets/gou.png" />实习报告/简历模板200+、PPT模板400+</div>
						</div>
					</div>
					<div class="popup-content-left-model">
						<div class="popup-content-left-model-title">
							解锁长期专属权益
						</div>
						<div class="popup-content-left-model-body">
							<div class="popup-content-left-model-body-font"><img
									class="popup-content-left-model-body-font-img"
									src="../assets/gou.png" />第一次获取网站新增内容和动态</div>
							<div class="popup-content-left-model-body-font"><img
									class="popup-content-left-model-body-font-img"
									src="../assets/gou.png" />直接反馈建议，参与网站优化</div>
							<div class="popup-content-left-model-body-font"><img
									class="popup-content-left-model-body-font-img" src="../assets/gou.png" />网站使用问题解答
							</div>
						</div>
					</div>
				</div>
				<div class="popup-content-right">
					<img class="popup-content-right-img" src="../assets/group.png" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				showPopup: false,
				canClose: false,
				countdown: 3,
				dontShowAgain: false,
				timer: null
			};
		},
		mounted() {
			const today = new Date().toISOString().split('T')[0];
			const lastShownDate = localStorage.getItem('popupLastShownDate');
			const dontShow = localStorage.getItem('popupDontShow');

			if (dontShow === 'true' || lastShownDate === today) return;

			this.showPopup = true;
			document.body.style.overflow = 'hidden'; // 禁止页面滚动

			const hasSeen = localStorage.getItem('popupHasSeen');
			if (!hasSeen) {
				this.startCountdown();
			} else {
				this.canClose = true;
			}

			localStorage.setItem('popupLastShownDate', today);
			localStorage.setItem('popupHasSeen', 'true');
		},
		methods: {
			startCountdown() {
				this.timer = setInterval(() => {
					this.countdown--;
					if (this.countdown <= 0) {
						clearInterval(this.timer);
						this.canClose = true;
					}
				}, 1000);
			},
			handleClose() {
				if (this.dontShowAgain) {
					localStorage.setItem('popupDontShow', 'true');
				}
				this.showPopup = false;
				document.body.style.overflow = '';
			}
		},
		beforeDestroy() {
			clearInterval(this.timer);
			document.body.style.overflow = '';
		}
	};
</script>

<style scoped>
	.popup-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.6);
		z-index: 9999;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.popup-box {
		/* Group 47096 */
		background: #fff;

		position: relative;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
		width: 720px;
		height: 465px;
		padding: 20px;
		border-radius: 12px;
		background: linear-gradient(125.38deg, #BCD9FA 0%, #FFFFFF 52.29%);



	}

	.popup-top-right {
		position: absolute;
		top: 10px;
		right: 10px;
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.checkbox-label {
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #333;
		gap: 4px;
	}

	.checkbox-label-input {
		background-color: transparent;
		/* 去掉白底 */
		border: none;
		/* 可选：去掉边框 */
		appearance: none;
		width: 14px;
		height: 14px;

		background: #FFFFFF;
		border: 2px solid #E5E6EB;
		border-radius: 2px;

		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 0;
	}

	.checkbox-label input[type="checkbox"]:checked::after {
		content: '';
		position: absolute;
		top: 5px;
		left: 8px;
		width: 3.71px;
		height: 6.85px;
		border: solid white;
		border-width: 0 2px 2px 0;
		transform: rotate(45deg);
	}

	.checkbox-label-input:checked {
		background: #165DFF;
		/* 蓝色背景 */
		border-color: #165DFF;
	}

	.close-btn {
		font-size: 18px;
		background: none;
		border: none;
		cursor: pointer;
		color: #888;
		font-weight: bold;
	}

	.countdown {
		font-size: 14px;
		color: #999;
	}

	.popup-content {
		margin-top: 40px;
		font-size: 16px;
		line-height: 1.5;
		text-align: center;

		display: flex;
		gap: 40px;
		margin-left: 40px;
		margin-top: 80px;
	}

	.popup-content-left {
		/* Frame 427321179 */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 0px;
		gap: 32px;

		/* position: relative; */
		/* width: 288px; */
		height: 264px;
		margin-top: 30px;
		/* 	left: 400px;
		top: 318px; */



	}

	.popup-content-right {
		/* Rectangle 24714 */

		box-sizing: border-box;

		position: relative;
		width: 323px;
		height: 319px;
		/* left: 717px;
		top: 302px; */

		background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, #FFFFFF 100%);
		backdrop-filter: blur(50px);
		/* Note: backdrop-filter has minimal browser support */
		border-radius: 12px;
		display: flex;
		justify-self: center;
		align-items: center;
		border: 1px solid #F2F3F5;
		 





	}

	.popup-content-right-img {
		/* Frame 427321181 */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0px;
		gap: 10px;


		width: 184px;
		height: 250px;
		margin: 0 auto;


	}

	.popup-content-left-model {
		/* Frame 427321177 */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 0px;
		gap: 12px;

		/* width: 278px; */
		height: 102px;


		/* Inside auto layout */
		flex: none;
		order: 0;
		align-self: stretch;
		flex-grow: 0;

	}

	.popup-content-left-model-title {
		/* 解锁长期专属权益 */

		/* width: 234px; */
		height: 34px;

		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 600;
		font-size: 24px;
		line-height: 140%;
		/* identical to box height, or 34px */

		/* 文字/text-5 */
		color: #1D2129;
		text-align: left;


		/* Inside auto layout */
		flex: none;
		order: 0;
		align-self: stretch;
		flex-grow: 0;

	}

	.popup-content-left-model-body {
		/* Frame 427321176 */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 0px;

		/* width: 278px; */
		height: 56px;


		/* Inside auto layout */
		flex: none;
		order: 1;
		align-self: stretch;
		flex-grow: 0;

	}

	.popup-content-left-model-body-font {
		/* 网站使用问题解答 */

		/* width: 112px; */
		height: 28px;

		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		line-height: 200%;
		/* identical to box height, or 28px */

		/* 文字/text-5 */
		color: #1D2129;
		text-align: left;


		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;
		display: flex;

		align-items: center;
		gap: 8px;


	}

	.popup-content-left-img {
		/* Group 47094 */

		position: absolute;
		top: 80px;
		width: 81px;
		height: 42.02px;
		background-image: url('../assets/xianshi.png');
		background-size: contain;
		background-repeat: no-repeat;

	}

	.popup-content-left-img-font {
		/* 限时 */


		/* width: 42px; */
		height: 28px;


		font-family: 'Alimama FangYuanTi VF';
		font-style: normal;
		font-weight: 700;
		font-size: 20px;
		line-height: 140%;
		/* identical to box height, or 28px */
		text-align: center;
		letter-spacing: 0.1em;

		color: #FFFFFF;
		text-align: center;
		margin-top: 3px;


	}

	.popup-content-left-model-body-font-img {
		width: 18px;
		height: 18px;
	}

	.checkbox-label-font {
		/* label */

		width: 56px;
		height: 22px;

		/* 14/CN-Regular
		
		正文-常规-大
		*/
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		line-height: 22px;
		/* identical to box height, or 157% */

		color: #1D2129;


		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;

	}
</style>